import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageMessages from 'Pages/messages';
import PageMessage from 'Pages/message';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={ PageMessages } />
			<Route exact path={`${match.url}/create`} component={ PageMessage } />
			<Route exact path={`${match.url}/edit/:messageId`} component={ PageMessage } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;